<template>
    <div></div>
</template>

<script type="text/javascript">
    export default {
        name : 'scroll',
        data () {
            return {

            }
        },
        created () {
            var self = this;
            window.onscroll = function () {
                if (self.getScrollTop() + self.getClientHeight() == self.getScrollHeight()) {
                    self.$emit('onBottom');
                }
            }
        },
        methods: {
            getScrollHeight () {
                var scrollHeight = 0;

                if(document.body.scrollHeight && document.documentElement.scrollHeight){
                    scrollHeight = Math.min(document.body.scrollHeight, document.documentElement.scrollHeight)
                }else {
                    scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                }

                return scrollHeight
            },

            //获取当前可视范围的高度
            getClientHeight () {
                var clientHeight = 0;

                if (document.body.clientHeight && document.documentElement.clientHeight) {
                    clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
                }else {
                    clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
                }

                return clientHeight;
            },

            //获取滚动条当前的位置
            getScrollTop () {
                var scrollTop = 0;

                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                }else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }

                return scrollTop;
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/plugin/scroll.vue